/**
 * A money amount from the API's decimal **string**, grouped without ever
 * becoming a float — `"12500000.00"` → `12,500,000.00 SYP`. The car page used
 * `Number(price).toLocaleString('en')`, which parses a decimal into a float.
 */
export function formatAmount(amount: string, currency: string): string {
  const match = /^(-?)(\d+)(\.\d+)?$/.exec(amount.trim());

  if (!match) {
    return `${amount} ${currency}`;
  }

  const whole = (match[2] ?? '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  // "42500000.00" reads as 42,500,000; a real fraction is kept exactly.
  const fraction = /^\.0+$/.test(match[3] ?? '') ? '' : (match[3] ?? '');

  return `${match[1] ?? ''}${whole}${fraction} ${currency}`;
}

/** A whole number with Western grouping: 148,250. */
export function formatCount(value: number): string {
  return String(Math.round(value)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
